<app-card [showHeader]="false" padding="15" cardClass="social-widget-card m-b-15 bg-accent-700">
  <strong >
    Dirección
  </strong>

  <p class="mat-body m-b-5 f-w-500">
    @if (!ready){
      <span class="col-span-1 h-4 rounded bg-white/40 my-5 animate-pulse">
        <span class="opacity-0">Cargando ...</span>
      </span>
    } @else {
      {{ resume?.lastAddress || 'No tiene dirección definida' }}
    }

  </p>
  <i class="fi fi-rr-direction-signal"></i>
</app-card>

<div class="row">
  <div class="col-{{ (resume?.hasIgnition) ? '6': '12' }}">
    <app-card [showHeader]="false" padding="15" cardClass="social-widget-card bg-warn-500 text-white">
      <div>Alertas hoy</div>

      <h3 class="m-b-5 f-w-500">
        @if (!ready){
          <span class="col-span-1 h-4 rounded bg-white/40 my-5 animate-pulse">
            <span class="opacity-0">Cargando ...</span>
          </span>
        } @else {
          {{ resume?.alertCount }}
        }
      </h3>

      <i class="fa-regular fa-bell"></i>
    </app-card>
  </div>

  @if (resume?.hasIgnition) {
    <div class="col-6">
      <app-card [showHeader]="false" padding="15" cardClass="social-widget-card bg-primary-500 text-white">
        <div>Horometro</div>

        <h3 class="m-b-5 f-w-500">
          @if (!ready) {
            <span class="col-span-1 h-4 rounded bg-white/40 my-5 animate-pulse">
              <span class="opacity-0">Cargando ...</span>
            </span>
          } @else {
            {{ ((resume?.workTimeHours || 0) * 60 * 60 * 1000 )  | renderDuration }}
          }
        </h3>

        <i class="fa-regular fa-clock"></i>
      </app-card>
    </div>

    <div class="col-6">
      <app-card [showHeader]="false" padding="15" cardClass="social-widget-card bg-success-500 text-white">
        <div>Encendido hace</div>
        <h3 class="m-b-5 f-w-500">
          @if(!ready){
            <span class="col-span-1 h-4 rounded bg-white/40 my-5 animate-pulse">
              <span class="opacity-0">Cargando ...</span>
            </span>
          } @else {
            @if (resume?.lastDeviceTimePowerOn) {
              <app-duration-text [dateValue]="resume?.lastDeviceTimePowerOn"></app-duration-text>
            } @else {
              Nunca
            }
          }
        </h3>


        <i class="fa-solid fa-power-off"></i>
      </app-card>
    </div>

    <div class="col-6">
      <app-card [showHeader]="false" padding="15" cardClass="social-widget-card bg-warning-500 text-white">
        <div>Apagado hace</div>

        <h3 class="m-b-5 f-w-500">
          @if(!ready){
            <span class="col-span-1 h-4 rounded bg-white/40 my-5 animate-pulse">
              <span class="opacity-0">Cargando ...</span>
            </span>
          } @else {
            @if(resume?.lastDeviceTimePowerOff) {
              <app-duration-text [dateValue]="resume?.lastDeviceTimePowerOff"></app-duration-text>
            } @else {
              Nunca
            }
          }
        </h3>

        <i class="fa-solid fa-circle-notch"></i>
      </app-card>
    </div>
  }
</div>

<app-card [showHeader]="false" padding="15" cardClass="social-widget-card bg-accent-500 text-white">
  <div>Odometro hoy</div>

  <h3 class="m-b-5 f-w-500">
    @if (!ready){
      <span class="col-span-1 h-4 rounded bg-white/40 my-5 animate-pulse">
        <span class="opacity-0">Cargando ...</span>
      </span>
    } @else {
      {{ ((resume?.distance || 0) * (calcVars?.distanceUnit?.multiply || 1)).toFixed(1) }}
      {{ calcVars?.distanceUnit?.abbr }}
    }

  </h3>
  <i class="fa-solid fa-gauge-high"></i>
</app-card>
